import type { FCC } from 'common/typeUtils';
import type { CSSProperties } from 'react';
import type { JSX } from 'react/jsx-runtime';

type Props = {
  as?: keyof JSX.IntrinsicElements;
  vertical?: boolean;
  gap?: CSSProperties['gap'];
  style?: CSSProperties;
  className?: string;
  alignItems?: CSSProperties['alignItems'];
  justifyContent?: CSSProperties['justifyContent'];
  wrap?: CSSProperties['flexWrap'];
};

/**
 * Simple Flex styling helper. Assign to element type of your choice via `as` prop.
 */
export const FlexBox: FCC<Props> = ({
  children,
  vertical,
  gap,
  as = 'div',
  style,
  className,
  alignItems,
  justifyContent,
  wrap: flexWrap,
}) => {
  const Element = as;
  const _style = Object.assign({ alignItems, justifyContent, flexWrap }, style, { display: 'flex', gap });
  if (vertical) {
    _style.flexDirection = 'column';
  }
  return (
    <Element className={className} style={_style}>
      {children}
    </Element>
  );
};
